(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atg-fitment-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atg-fitment-selector')) {
    customElements.define('atg-fitment-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        requestAnimationFrame(() => this.init());
      }
      init() {
        this.scope = this.closest('.shopify-section');
        this.items = Array.from(this.scope.querySelectorAll('[data-fitment-item]'));
        if (!this.items.length) return;
        this.hidden = false;
        const params = new URLSearchParams(location.search);
        this.vesa = params.get('fit_vesa') || '';
        this.movement = params.get('fit_movement') || '';
        this.weight = this.querySelector('[data-weight]');
        this.weight.value = params.get('fit_weight') || '';
        const more = this.querySelector('[data-more]');
        const all = new Set(this.items.flatMap(item => (item.dataset.patterns || '').split('|').filter(Boolean)));
        const main = Array.from(this.querySelectorAll('[data-vesa]')).map(b => b.dataset.vesa);
        Array.from(all).filter(s => !main.includes(s)).sort((a,b) => parseInt(a)-parseInt(b)).forEach(s => more.add(new Option(s.replace('x',' × '), s)));
        if (this.vesa && !main.includes(this.vesa) && !all.has(this.vesa)) more.add(new Option(this.vesa.replace('x',' × '), this.vesa));
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-clear')) { this.vesa = ''; this.movement = ''; this.weight.value = ''; }
          if (button.hasAttribute('data-vesa')) this.vesa = button.dataset.vesa;
          if (button.hasAttribute('data-movement')) this.movement = button.dataset.movement;
          this.apply();
        });
        this.addEventListener('input', event => { if (event.target === this.weight) this.apply(); });
        this.addEventListener('change', event => {
          if (event.target === more) { this.vesa = more.value; this.apply(); }
          if (event.target.matches('[data-sort]')) { const url = new URL(location.href); url.searchParams.set('sort_by',event.target.value); url.searchParams.delete('page'); location.assign(url); }
        });
        this.apply();
      }
      apply() {
        const weight = Number(this.weight.value);
        const invalid = this.weight.value !== '' && (!this.weight.validity.valid || weight <= 0);
        let count = 0;
        this.items.forEach(item => {
          const patterns = (item.dataset.patterns || '').split('|');
          const maxWeight = Number(item.dataset.maxWeight);
          const matches = !invalid && (!this.vesa || patterns.includes(this.vesa)) && (!this.movement || item.dataset.movement === this.movement) && (!weight || maxWeight > 0 && maxWeight >= weight);
          item.hidden = !matches;
          if (matches) count++;
        });
        this.querySelectorAll('[data-vesa]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.vesa === this.vesa)));
        this.querySelectorAll('[data-movement]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.movement === this.movement)));
        const more = this.querySelector('[data-more]');
        more.value = Array.from(more.options).some(option => option.value === this.vesa) ? this.vesa : ''; 
        const status = this.querySelector('[data-count]');
        status.textContent = status.dataset.template.replace('COUNT',String(count));
        this.querySelector('[data-empty]').hidden = count > 0;
        const url = new URL(location.href);
        for (const [key,value] of [['fit_vesa',this.vesa],['fit_movement',this.movement],['fit_weight',this.weight.value]]) { if(value) url.searchParams.set(key,value); else url.searchParams.delete(key); }
        history.replaceState(null,'',url);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
